export const START_UP_1 = '1' // 自己的活动且未注册
export const START_UP_2 = '2' // 非自己的活动（通常是指从其他人分享的链接进入）
export const START_UP_3 = '3' // 自己的活动且已注册